import * as i18n from './i18n';
import isLoading from './isLoading';
import notice from './notice';
export * from './activeMap';
export * from './i18n';

const selectors = {
  ...i18n,
  isLoading,
  notice,
};

export default selectors;
